import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../../../external-components/angular-material.module';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { RouterModule } from '@angular/router';
import { CalibrationPlanEditComponent } from './calibration-plan-edit.component';
import { CalibrationPlanEditFolderComponent } from './calibration-plan-edit-folder.component';
import { CalibrationPlanEditCustomFieldComponent } from './calibration-plan-edit-custom-field.component';
import { CalibrationPlanEditGenerateDialogComponent } from './calibration-plan-edit-generate-dialog/calibration-plan-edit-generate-dialog.component';
import { CalibrationPlanEditGenerateReportDialogComponent } from './calibration-plan-edit-generate-report-dialog/calibration-plan-edit-generate-report-dialog.component';
import { CalibrationPlanEditManualSignReportDialogComponent } from './calibration-plan-edit-manual-sign-report-dialog/calibration-plan-edit-manual-sign-report-dialog.component';



@NgModule({
  declarations: [CalibrationPlanEditComponent, CalibrationPlanEditFolderComponent, CalibrationPlanEditCustomFieldComponent, 
    CalibrationPlanEditGenerateDialogComponent, CalibrationPlanEditGenerateReportDialogComponent, CalibrationPlanEditManualSignReportDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,
    /* Otros */
    FlexLayoutModule,
    RouterModule
  ], 
  exports: [CalibrationPlanEditComponent, CalibrationPlanEditFolderComponent, CalibrationPlanEditCustomFieldComponent, 
    CalibrationPlanEditGenerateDialogComponent
  ]
})
export class CalibrationPlanEditModule { }
